import * as React from "react";
import {
  Grid,
  Typography,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Fab,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import {
  Search,
  Add as AddIcon,
  AddCircle as Remove,
} from "@material-ui/icons";
import LayerAddRateLibrary from "modules/rateLibrary/components/layouts/LayerAddRateLibrary";
import { RateLibraryStore } from "modules/rateLibrary/RateLibraryStore";
import { LoginStore } from "modules/login/LoginStore";
import i18n from "i18n";
import { observer } from "mobx-react";
//import Select from 'react-select';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "64px",
  },
  title: {
    lineHeight: "64px",
    fontSize: "16px",
    fontFamily: "Raleway",
  },
  addRateLibrary: {
    top: "36px",
    left: "calc(50% - 28px)",
    zIndex: "2" as any,
  },
  tabsRoot: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    boxShadow: "unset",
    width: "fit-content",
    fontSize: "12px",
  },
  tabsIndicator: {
    height: 0,
  },
  tabRoot: {
    padding: `0px ${theme.spacing.unit * 2}px`,
    minWidth: "unset",
    border: "unset",
    fontWeight: 500,
    "&$tabSelected > :first-child": {
      borderBottom: `3px solid ${theme.palette.primary.light}`,
      fontWeight: 700,
    },
    "&:hover": {
      color: theme.palette.primary.light,
    },
    transition: "all 0.3s ease-in",
  },
  tabSelected: {
    color: theme.palette.primary.light,
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabWrapper: {
    height: "63px",
    display: "block",
    lineHeight: "63px",
    fontFamily: "Raleway",
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
  iconSearch: {
    color: "#777777",
    left: 8,
    top: 4,
  },
  iconRemove: {
    color: "#bababa",
    right: 8,
    top: 6,
    transform: "rotate(45deg)",
    fontSize: "21px",
    cursor: "pointer",
    pointerEvents: "none" as any,
    transition: "opacity 300ms ease-in",
    opacity: 0,
  },
  inputSearch: {
    outlineColor: theme.palette.primary.light,
    fontFamily: "Roboto",
    width: "100%",
    fontWeight: 400,
    fontSize: "14px",
    padding: "7px 30px 7px 40px",
    color: "#212121",
    border: "1px solid #cccccc",
    borderRadius: "2px",
    transition: "all 0.3s ease-in",
    "&:valid ~ #remove": {
      opacity: 1,
      pointerEvents: "auto" as any,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      border: "1px solid #ABC200",
    },
  },
  selectSearch: {
    outlineColor: theme.palette.primary.light,
    fontFamily: "Roboto",
    width: "100%",
    fontWeight: 400,
    fontSize: "14px",
    padding: "1px 4px 0px 10px",
    color: "#212121",
    border: "1px solid #cccccc",
    borderRadius: "2px",
    "&:valid ~ #remove": {
      opacity: 1,
      pointerEvents: "auto" as any,
    },
    "&::before": {
      borderBottom: "none !important",
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

type IProps = {
  classes: any;
};

@observer
class SearchHeader extends React.Component<IProps> {
  state = {
    currentTab: 0,
    layerAdd: false,
    defaultLocation: "",
  };

  handleTabsChange = (event, value) => {
    RateLibraryStore.currentTab = value;
    if (
      RateLibraryStore.search !== "" ||
      RateLibraryStore.stateSearch !== "BR"
    ) {
      if (value === 0)
        RateLibraryStore.librariesView = RateLibraryStore.librariesSearch;
      else
        RateLibraryStore.librariesView = RateLibraryStore.publicLibrariesSearch;
    }
    this.setState({ currentTab: value });
  };

  handleInputChange = (e) => {
    RateLibraryStore.search = e.target.value;

    this.applyLibraryFilters();
  };

  handleChange = (event) => {
    if (LoginStore.userAuth != undefined)
      LoginStore.userAuth.defaultLocation = event.target.value;
    this.setState({ defaultLocation: event.target.value });

    RateLibraryStore.stateSearch = event.target.value;

    this.applyLibraryFilters();
  };

  private applyLibraryFilters() {
    let textFilter = RateLibraryStore.search ? RateLibraryStore.search : "";
    let stateFilter =
      !RateLibraryStore.stateSearch || RateLibraryStore.stateSearch === "BR"
        ? ""
        : RateLibraryStore.stateSearch;
    let filterLibraries: any = [];
    if (textFilter !== "" || stateFilter !== "BR") {
      RateLibraryStore.librariesSearch = RateLibraryStore.myLibraries.filter(
        function (lib) {
          return (
            lib.data.name.toLowerCase().includes(textFilter.toLowerCase()) &&
            (stateFilter === "" ||
              lib.data.location === undefined ||
              lib.data.location.indexOf(stateFilter) >= 0)
          );
        }
      );
      RateLibraryStore.publicLibrariesSearch =
        RateLibraryStore.publicLibraries.filter(function (lib) {
          return (
            lib.data.name
              .toLowerCase()
              .includes(RateLibraryStore.search.toLowerCase()) &&
            (stateFilter === "" ||
              lib.data.location === undefined ||
              lib.data.location.indexOf(stateFilter) >= 0)
          );
        });

      filterLibraries =
        RateLibraryStore.currentTab === 0
          ? RateLibraryStore.librariesSearch
          : RateLibraryStore.publicLibrariesSearch;
    }

    RateLibraryStore.librariesView = filterLibraries;
  }

  handleCleanFilter = () => {
    RateLibraryStore.search = "";

    let quantityInput = document.getElementById("searchInput");
    if (quantityInput) {
      (quantityInput as any).value = "";
    }

    this.applyLibraryFilters();
  };

  handleOpenLayerAdd = () => {
    RateLibraryStore.layerAdd = true;
  };

  componentDidMount = () => {
    if (LoginStore.userAuth != undefined)
      this.setState({
        defaultLocation:
          LoginStore.userAuth.defaultLocation != undefined
            ? LoginStore.userAuth.defaultLocation
            : "BR",
      });
    // this.setState({defaultLocation: "BR"})
  };

  render() {
    const { classes } = this.props,
      { currentTab } = this.state,
      tabClasses = {
        root: classes.tabRoot,
        selected: classes.tabSelected,
        labelContainer: classes.tabLabelContainer,
        wrapper: classes.tabWrapper,
      };

    const suggestions = [
      { label: "Brasil", value: "BR" },
      { label: "Acre", value: "AC" },
      { label: "Alagoas", value: "AL" },
      { label: "Amapá", value: "AP" },
      { label: "Amazonas", value: "AM" },
      { label: "Bahia", value: "BA" },
      { label: "Ceará", value: "CE" },
      { label: "Distrito Federal", value: "DF" },
      { label: "Espírito Santo", value: "ES" },
      { label: "Goiás", value: "GO" },
      { label: "Maranhão", value: "MA" },
      { label: "Mato Grosso", value: "MT" },
      { label: "Mato Grosso do Sul", value: "MS" },
      { label: "Minas Gerais", value: "MG" },
      { label: "Pará", value: "PA" },
      { label: "Paraíba", value: "PB" },
      { label: "Paraná", value: "PR" },
      { label: "Pernambuco", value: "PE" },
      { label: "Piauí", value: "PI" },
      { label: "Rio de Janeiro", value: "RJ" },
      { label: "Rio Grande do Norte", value: "RN" },
      { label: "Rio Grande do Sul", value: "RS" },
      { label: "Rondônia", value: "RO" },
      { label: "Roraima", value: "RR" },
      { label: "Santa Catarina", value: "SC" },
      { label: "São Paulo", value: "SP" },
      { label: "Sergipe", value: "SE" },
      { label: "Tocantins", value: "TO" },
    ];

    return (
      <Grid container className={classes.container}>
        <LayerAddRateLibrary />
        <Grid item xs={2}>
          <div
            style={{
              maxWidth: "250px",
              whiteSpace: "nowrap",
            }}
          >
            <Tooltip title={i18n.menu.rateLibrary}>
              <Typography
                className={classes.title}
                style={{
                  textAlign: "left",
                  paddingLeft: "28px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                component="h2"
              >
                {i18n.menu.rateLibrary}
              </Typography>
            </Tooltip>
          </div>
        </Grid>
        <Grid item xs={4}>
          <Tabs
            value={currentTab}
            onChange={this.handleTabsChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              classes={tabClasses}
              label={i18n.rateLibraries.dashHeader.mine}
            />
            <Tab
              classes={tabClasses}
              label={i18n.rateLibraries.dashHeader.public}
            />
          </Tabs>
        </Grid>
        <Grid item xs={2} className={classes.gridSearch}>
          <div>
            <label
              style={{ position: "relative", float: "right", width: "95%" }}
            >
              <Select
                className={classes.selectSearch}
                style={{ width: "100%" }}
                value={this.state.defaultLocation}
                onChange={this.handleChange}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                      width: 200,
                      marginTop: 2,
                    },
                  },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                {suggestions.map((suggest, index) => (
                  <MenuItem key={index} value={suggest.value}>
                    {suggest.label.toString()}
                  </MenuItem>
                ))}
              </Select>
            </label>
          </div>
        </Grid>
        <Grid item xs={2} className={classes.gridSearch}>
          <div>
            <label
              style={{ position: "relative", float: "right", width: "95%" }}
            >
              <Search
                style={{ position: "absolute" }}
                className={classes.iconSearch}
              />
              <input
                type="text"
                ref="inputSearch"
                className={classes.inputSearch}
                placeholder={i18n.rateLibraries.dashHeader.search}
                onChange={this.handleInputChange}
                required
                id="searchInput"
              />
              <Remove
                id="remove"
                style={{ position: "absolute" }}
                className={classes.iconRemove}
                onClick={this.handleCleanFilter}
              />
            </label>
          </div>
        </Grid>
        <Grid item xs={2} style={{ position: "relative" }}>
          <Fab
            onClick={this.handleOpenLayerAdd}
            color="primary"
            className={classes.addRateLibrary}
            style={{ position: "absolute" }}
            title={i18n.rateLibraries.layerAdd.addTitle}
          >
            <AddIcon />
          </Fab>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SearchHeader);



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/components/layouts/SearchHeader.tsx